VogUtils.DOMready(() => {
  const sortSelect_new = document.getElementById("SortBy_new");
  if (sortSelect_new) {
    const defaultSort_new = getDefaultSortValue_new();
    sortSelect_new.addEventListener("click", function (event) {
      onSortClick(event);
    });
  }
  function onSortClick(event) {
    const options = sortSelect_new.querySelector(".select-options_new");
    const img = document.querySelector(".sort-by-icon_new");
    const optionItems = sortSelect_new.querySelectorAll(".select-option_new");
    if (options.style.display === "block") {
      options.style.display = "none";
      img.classList.remove("up");
    } else {
      options.style.display = "block";
      img.classList.add("up");
    }
    optionItems.forEach((option) => {
      option.addEventListener("click", () => {
        const value = option.dataset.value;
        const url = new URL(window.location.href);
        url.searchParams.set("sort_by", value);
        window.location.href = url.toString();
        // this.onSortChange()
      });
    });
  }
  function getDefaultSortValue_new() {
    return sortSelect_new.getAttribute("data-default-sortby_new");
  }
  // 初始化判断当前激活 tab
  const currentTab = $vog(".search_tab_active").data("tab");
  if (!currentTab) {
    $vog(".collection-filter__item--sort").show();
    return;
  }
  function updateFilterVisibility(tab) {
    if (tab === "search_tab_products") {
      $vog(".collection-filter__item--sort").show();
    } else {
      $vog(".collection-filter__item--sort").hide();
    }
  }
  updateFilterVisibility(currentTab);

  // 点击 tab 切换内容和样式
  $vog(".search_tab-button").on("click", function () {
    const tab = $(this).data("tab");

    // 切换内容区域
    $vog(".search_tab-content").hide();
    $vog("#" + tab).show();

    // 更新筛选区域可见性
    updateFilterVisibility(tab);

    // 更新激活样式
    $vog(".search_tab-button").removeClass("search_tab_active");
    $vog(this).addClass("search_tab_active");
  });
});

async function getCollectionMenusData() {
  const menuHandle = JSON.parse(document.getElementById('vog-header-current-menu-handle')?.textContent || '"main-menu"');
  const root = (window.theme && window.theme.routes && window.theme.routes.home) || '/';
  const endpoint = `${root}?view=vog-main-menu-data&handle=${encodeURIComponent(menuHandle)}`;
  const response = await fetch(endpoint, { method: 'GET', credentials: 'same-origin' });
  if (!response.ok) return;
  const menusData = await response.json();
  if (!menusData || menusData.length === 0) return;
  const collectionData = menusData.filter(
    (menu) => menu.type === "collection_link" || menu.type === "product_link" || menu.type === "collections_link"
  );
  console.log(collectionData, menusData, "collectionData");
  let html = "";
  collectionData.forEach((item, index) => {
    item.id = index;
    item.url = decodeURIComponent(item.url);
    html += filterHtml(item, index);
  });

  $vog(".collection-filters-container").html(html);

  $vog(document).on("click", ".collection-fitler-item", function (e) {
    const id = $vog(e.currentTarget).data("id");
    const $arrow = $vog(".arrow" + id);
    $arrow.toggleClass("down");
    setCollectionDetail(collectionData, id);
  });

  // 默认展开包含匹配项的类目
  collectionData.forEach((item) => {
    if (item.current || item.child_active) {
      setCollectionDetail(collectionData, item.id);
    }
  });
}
function filterHtml(item) {
  const arrowClass = item.current || item.child_active ? "down" : "";
  const html =
    item.links && item.links.length > 0
      ? ` <div class="collection-fitler-item"  data-id="${item.id}">
        <div class="collection-item-title">${item.title}</div>
        <img class="collection-item-img ${arrowClass} arrow${item.id}" src="https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Down.svg?v=1753349471" alt="">
      </div>
      <div  class="collection-detail-container collectionDetailItem${item.id}"></div> `
      : ` <a class="collection-fitler-item" data-id="${item.id}" href="${item.url}">
          <div class="collection-item-title">${item.title}</div>
          <img  class="collection-item-img ${arrowClass} arrow${item.id}" src="https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Down.svg?v=1753349471" alt="">
      </a>`;
  return html;
}
function setCollectionDetail(collectionData, id) {
  const $detailContainer = $vog(".collectionDetailItem" + id);
  const isExpanded = $detailContainer.is(".active");
  if (isExpanded) {
    $detailContainer.removeClass("active");
  } else {
    $detailContainer.addClass("active");
    const selectedItem = collectionData.find((item) => item.id == id);
    if (!selectedItem.links) return;
    let html = "";
    const current = window.location.pathname === decodeURIComponent(selectedItem.url);
    const exists = selectedItem.links.some((item) => item.title === "all" && item.url === selectedItem.url);
    if (!exists) {
      selectedItem.links.unshift({
        url: selectedItem.url,
        title: "all",
        products_count: selectedItem.products_count,
        current: current,
      });
    }
    selectedItem.links.forEach((item) => {
      html += filterHtmlDetail(item);
    });
    console.log(selectedItem, "selectedItem");
    $vog(`.collectionDetailItem${id}`).html(html);
  }
}
function filterHtmlDetail(item) {
  return `
    <a class="collection-detail" href="${item.url}">
      <img class="collection-detail-img" src="${
        item.current
          ? "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Group_171.svg?v=1753349478"
          : "https://cdn.shopify.com/s/files/1/0707/8078/0796/files/Ellipse_3.svg?v=1753349471"
      }" alt="">
      <div class="collection-detail-title">${item.title} ${
    item.products_count ? "(" + item.products_count + ")" : ""
  }</div> 
    </a>`;
}

VogUtils.DOMready(async () => {
  await getCollectionMenusData();
});
